import { Suspense } from 'react';
import { useIntl } from 'react-intl';

import { ErrorStateFallback } from '@/components/ui/error-state';
import { Header } from '@/components/ui/header';
import { Title } from '@/components/ui/title';

import { SettingsPage } from './settings-page';

export function Settings() {
  const intl = useIntl();
  const settingsIntl = intl.formatMessage({
    defaultMessage: 'Settings',
  });

  return (
    <main className="relative flex flex-1 flex-col gap-4 px-6 py-2">
      <ErrorStateFallback>
        <Header headers={[{ title: settingsIntl }]} />
        <Title title={settingsIntl} />
        <Suspense fallback={<SettingsPage.Skeleton />}>
          <SettingsPage />
        </Suspense>
      </ErrorStateFallback>
    </main>
  );
}
